import { jsx as _jsx } from "react/jsx-runtime";
import LegacyNotifications from 'legacy/_views/LenderViews/UserAlerts';
import { Page } from 'xen/components';
const Notifications = () => {
    // Should eventually be replaced by new Xen 1.0 Notifications page
    return (_jsx(Page, { pt: "0", children: _jsx(LegacyNotifications, {}) }));
};
export default Notifications;
